export default __webpack_public_path__ + "static/media/Dollar.1dc52f39.png";